import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppSettingModel } from '../models/app-setting-model';
import { BaseService } from './base.service';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class AppSettingService extends BaseService {

  private LastIndexSubject = new Subject<string>();
  lastAdamsUpdateKey = 'LastAdamsUpdate';
  lastIndexUpdate = '';

  constructor(public override http: HttpClient,
    public override constants: ConstantsService) {
    super(http, constants, constants.api_appSettings);
  }

  setLastIndex(lastIndex: AppSettingModel) {
    this.lastIndexUpdate = lastIndex.settingValue;
    this.LastIndexSubject.next(lastIndex.settingValue);
  }

  getLastIndexObservable() { 
    return this.LastIndexSubject.asObservable();
  }

  getByName(name: string): Observable<AppSettingModel> {
    return this.http.get<AppSettingModel>(this.constants.api_appSettings + "/" + name + environment.api_code)
  }

  getLastAdamsUpdate(): Observable<AppSettingModel> {
    return this.getByName(this.lastAdamsUpdateKey);
  }

}
